import type { LinkProps} from '@chakra-ui/react'
import { Link as ChakraLink, Icon, Text } from '@chakra-ui/react'
import { faLinkHorizontal } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CustomTooltip from 'BrokerTsLib/src/components/CustomTooltip'
import { Link as ReactRouterLink } from 'react-router'

interface FlexGroupLinkProps extends LinkProps {
  flexGroupId?: number
  name?: string
  showId?: boolean
}

export const FlexGroupLink = ({ flexGroupId, name, showId, ...rest }: FlexGroupLinkProps) => {
  return (
    <CustomTooltip
      display='flex'
      placement='bottom-start'
      label={
        <>
          {name}
          <Text as="span" color="gray.500">
            {', '}
            Id: {flexGroupId}
          </Text>
        </>
      }
    >
      <ChakraLink
        as={ReactRouterLink}
        to={`/flex-group/${flexGroupId}`}
        {...rest}
        sx={{ whiteSpace: 'nowrap', ...rest.sx }}
      >
        {name}
        <Icon
          as={FontAwesomeIcon}
          icon={faLinkHorizontal}
          ml={1.5}
          opacity={0.5}
        />
      </ChakraLink>
    </CustomTooltip>
  )
}